/* eslint-disable no-unused-vars */
const state = {}

const mutations = {}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise(resolve => {
      resolve()
    })
  },

  register({ commit }, form) {
    return new Promise(resolve => {
      resolve()
    })
  },

  forgetPassword({ commit }, form) {
    return new Promise(resolve => {
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
